(function (Drupal) {
  'use strict';

  Drupal.behaviors.stickyIsi = {
    attach: function (context, settings) {
      const stickyIsi = document.querySelector('.sticky-isi');
      const isiComponent = document.querySelector('#isi');
      const mm = matchMedia("(min-width: 992px)");
      let marginOffset = stickyIsi ? stickyIsi.offsetHeight : (mm.matches ? 230 : 185);
      let observer = null;
      let debounceTimer = null;

      if (!stickyIsi || !isiComponent) {
        return;
      }

      function setStickyVisibility(visible) {
        if (debounceTimer) cancelAnimationFrame(debounceTimer);
        debounceTimer = requestAnimationFrame(function () {
          stickyIsi.style.display = visible ? 'block' : 'none';
        });
      }

      mm.addEventListener('change', function (e) {
        marginOffset = stickyIsi.offsetHeight || (e.matches ? 230 : 185);

        observer.disconnect();

        observer = createObserver();
      });

      const isiToggleBtn = isiComponent.querySelector('.btn-toggle');
      const stickyToggleBtn = stickyIsi.querySelector('.btn-toggle');

      const createObserver = () => {
        const observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                isiComponent.classList.add('open');
                setStickyVisibility(false);
                if (isiToggleBtn) isiToggleBtn.setAttribute('aria-expanded', 'true');
                if (stickyToggleBtn) stickyToggleBtn.setAttribute('aria-expanded', 'true');
              } else {
                isiComponent.classList.remove('open');
                if (isiToggleBtn) isiToggleBtn.setAttribute('aria-expanded', 'false');
                if (stickyToggleBtn) stickyToggleBtn.setAttribute('aria-expanded', 'false');

                setStickyVisibility(entry.boundingClientRect.top > 0);
              }
            });
          },
          {
            rootMargin: `0px 0px -${marginOffset}px 0px`,
            threshold: 0
          }
        )

        observer.observe(isiComponent);

        return observer;
      }

      observer = createObserver();
    }
  };
})(Drupal);
